import { Modal, Space } from "antd";
import { NavigateFunction } from "react-router";
import { getEnvironmentService } from "../../backend";
import { trackUndeployInit } from "../../backend/tracking/deployment";

interface IUndeployEnvironmentProps {
    envId: string;
    projectId: string;
    navigate: NavigateFunction;
}

interface IUndeployEnvironmentModalProps extends IUndeployEnvironmentProps {
    envStatus: string;
}

export async function handleUndeployEnvironment({
    envId,
    projectId,
    navigate
}: IUndeployEnvironmentProps) {
    await getEnvironmentService().undeployStage(envId!, projectId);
    trackUndeployInit(envId!);
    navigate(`/projects/${projectId}/environments/${envId}/deployments`);
}

export const showUndeployEnvironmentModalConfirm = ({
    envId,
    envStatus,
    projectId,
    navigate
}: IUndeployEnvironmentModalProps) => {
    Modal.confirm({
        title: "Environment cannot be deployed",
        content:
            <Space direction='vertical'>
                <div>
                    Stack is in <b>{envStatus}</b> status, you must undeploy it first
                </div>
            </Space>,
        okText: "Undeploy",
        centered: true,
        onOk: () => handleUndeployEnvironment({
            envId,
            projectId,
            navigate
        })
    });
}